module.exports = __webpack_public_path__ + "img/W-G23.15d2cf7c.jpg";